import { Component, OnInit, AfterViewInit, ElementRef, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { LocalService } from './local.service';
import Hls from 'hls.js';

@Component({
  selector: 'nc-video-hls',
  templateUrl: './video-hls.component.html',
  styleUrls: ['./video-hls.component.less']
})
export class VideoHlsComponent implements OnInit, AfterViewInit, OnDestroy {
  SHOW_LOADING = "loading...";
  SHOW_DONE = "done.";
  isH265: boolean = true;
  isPlaying: boolean = false;
  muteState: boolean = true;
  isFullScreenBtn: boolean = false;
  networkState: number = 1;//1：加载中 2：视频地址超时 3：视频地址格式错误 4：初始化组件失败 5：成功
  player: any;
  glplayerId: string = 'glplayer' + '_' + new Date().getTime() + '_' + Math.random().toString(36).substring(2, 15);
  initMissileOk: boolean = false;
  private fullscreenHandler: ((event: Event) => void) | null = null;
  private static currentFullscreenPlayerId: string | null = null;//静态属性来记录当前全屏的播放器ID
  private static h265webjsLoaded: boolean = false; // 添加静态变量跟踪脚本加载状态
  private static missileLoaded: boolean = false; // 添加静态变量跟踪missile加载状态
  private originalConsoleLog: any; // 添加属性保存原始 console.log
  private canvasStyle: any = {
    marginLeft: 0,
    marginTop: 0,
    width: 0,
    height: 0
  };

  @Input() ncUrl: string = '';//视频地址
  @Input() ncErrorTime: number = 8;//视频地址错误检测时间
  //自动播放
  @Input() set ncAutoplay(value: boolean | string) {
    this.autoplayMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //静音
  @Input() set ncMuted(value: boolean | string) {
    this.mutedMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //隐藏控制栏
  @Input() set ncControls(value: boolean | string) {
    this.controlsMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  @Output() ncPlaying = new EventEmitter<boolean>();//返回播放状态
  @Output() ncLoaded = new EventEmitter<any>();//返回播放器

  autoplayMode: boolean = false;
  mutedMode: boolean = true;
  controlsMode: boolean = true;


  constructor(private elementRef: ElementRef, private ls: LocalService) {
    //重写console.log来捕获所有输出
    this.originalConsoleLog = console.log; // 保存原始 console.log
    console.log = (...args) => {
      this.originalConsoleLog.apply(console, args);
      const message = args.join(' ');
      if (message.includes('onReadyShowDone')) {
        this.originalConsoleLog('检测到missile初始化成功！');
        this.initMissileOk = true;
      }
    };
    // 只在第一次实例化时加载脚本
    if (!VideoHlsComponent.h265webjsLoaded) {
      this.ls.loadScript('assets/h265webjs-js/h265webjs-v20211104.js');
      VideoHlsComponent.h265webjsLoaded = true;
    }
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
    if (this.ls.getFileExtension(this.ncUrl) !== 'm3u8') {
      console.error("视频地址格式错误！仅支持m3u8格式！");
      this.networkState = 3;
      return;
    }

    this.waitForPlayerLoad();
  }

  ngOnDestroy(): void {
    // 恢复原始的 console.log
    if (this.originalConsoleLog) {
      console.log = this.originalConsoleLog;
    }
    // 移除全屏事件监听器
    if (this.fullscreenHandler) {
      document.removeEventListener('fullscreenchange', this.fullscreenHandler);
      this.fullscreenHandler = null;
    }
    //销毁 h265webjs player
    try {
      if (this.player && typeof this.player.release === 'function') {
        this.player.release();
      }
    } catch (error) {
      console.warn('播放器销毁失败:', error);
    }
    //销毁 hls.js player
    this.destroyAll();
  }

  //等待265webjs加载完成
  private waitForPlayerLoad() {
    if (!(window as any).new265webjs) {
      setTimeout(() => {
        this.waitForPlayerLoad();
      }, 100);
      return;
    }

    //初始化
    this.initPlayer();

    // 8秒后通过打印台信息检查missile是否初始化成功
    setTimeout(() => {
      if (!this.initMissileOk) {
        console.log("missile初始化失败！");
        this.networkState = 4;
      }
    }, this.ncErrorTime * 1000)
  }

  //初始化
  async initPlayer() {
    var token = "base64:QXV0aG9yOmNoYW5neWFubG9uZ3xudW1iZXJ3b2xmLEdpdGh1YjpodHRwczovL2dpdGh1Yi5jb20vbnVtYmVyd29sZixFbWFpbDpwb3JzY2hlZ3QyM0Bmb3htYWlsLmNvbSxRUTo1MzEzNjU4NzIsSG9tZVBhZ2U6aHR0cDovL3h2aWRlby52aWRlbyxEaXNjb3JkOm51bWJlcndvbGYjODY5NCx3ZWNoYXI6bnVtYmVyd29sZjExLEJlaWppbmcsV29ya0luOkJhaWR1";
    // var url = "http://182.140.3.24:9999/rtp/51332300001320000001_51332300001320000001/hls.m3u8";//265 canvas
    // var url = "https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/hls/xgplayer-demo.m3u8";//264 vjs
    // var url = "http://pull-demo.volcfcdnrd.com/live/st-4536521_yzmuhevcd.flv";//265
    // var url = "https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo-360p.flv";//264 flvjs

    //检查流地址是否可访问
    this.networkState = 1;
    try {
      const isAvailable = await this.ls.checkStreamUrl(this.ncUrl);
      if (!isAvailable) {
        this.networkState = 2;
        return;
      }
    } catch (error) {
      this.networkState = 2;
      return;
    }

    let width = this.elementRef.nativeElement.offsetWidth;
    let height = this.elementRef.nativeElement.offsetHeight;

    var config = {
      player: this.glplayerId,
      width: width,
      height: height,
      token: token,
      extInfo: {
        coreProbePart: 0.4,
        probeSize: 8192
      }
    };

    let playerObj = (window as any).new265webjs(this.ncUrl, config);
    this.player = playerObj;

    //加载missile（如果放在构造函数中加载的话，会产生可能不去加载视频地址导致的初始化失败问题）
    if (!VideoHlsComponent.missileLoaded) {
      this.ls.loadScript('assets/h265webjs-js/missile.js');
      VideoHlsComponent.missileLoaded = true;
    }

    let playerCont: any = this.elementRef.nativeElement.querySelector('#player-container');
    let controllerCont: any = this.elementRef.nativeElement.querySelector('#controller');
    let progressCont: any = this.elementRef.nativeElement.querySelector('#progress-contaniner');
    let progressContW = progressCont.offsetWidth;
    let cachePts: any = progressCont.querySelector('#cachePts');
    let progressPts: any = progressCont.querySelector('#progressPts');
    let progressVoice: any = this.elementRef.nativeElement.querySelector('#progressVoice');
    let playBtn: any = this.elementRef.nativeElement.querySelector('#playBtn');
    let showLabel: any = this.elementRef.nativeElement.querySelector('#showLabel');
    let ptsLabel: any = this.elementRef.nativeElement.querySelector('#ptsLabel');
    let coverToast: any = this.elementRef.nativeElement.querySelector('#coverLayer');
    let coverBtn: any = this.elementRef.nativeElement.querySelector('#coverLayerBtn');
    let muteBtn: any = this.elementRef.nativeElement.querySelector('#muteBtn');
    let fullScreenBtn: any = this.elementRef.nativeElement.querySelector('#fullScreenBtn');
    let mediaInfo: any = null;

    playBtn.disabled = true;
    showLabel.textContent = this.SHOW_LOADING;
    playerCont.style.width = config.width + 'px';
    playerCont.style.height = config.height + 'px';
    controllerCont.style.width = config.width + 'px';

    //播放方法
    let playAction = () => {
      if (playerObj.isPlaying()) {
        console.log("bar pause============>");
        playerObj.pause();
        this.isPlaying = false;
        coverToast.removeAttribute('hidden');
      } else {
        console.log("bar play============>");
        playerObj.play();
        this.isPlaying = true;
        coverToast.setAttribute('hidden', 'hidden');
      }

      this.ncPlaying.emit(this.isPlaying);
    };

    playerCont.onmouseover = () => {
      if (!this.controlsMode) {
        controllerCont.hidden = true;
      } else {
        controllerCont.hidden = false;
      }
    };

    controllerCont.hidden = true;//默认隐藏工具栏，不在html中设置是因为前方需要获取宽度
    playerCont.onmouseout = () => {
      controllerCont.hidden = true;
    };

    //播放按钮点击事件
    playBtn.onclick = () => {
      playAction();
    };

    //静音按钮点击事件
    muteBtn.onclick = () => {
      // console.log(playerObj.getVolume());
      if (this.muteState) {
        playerObj.setVoice(1.0);
        progressVoice.value = 100;
      } else {
        playerObj.setVoice(0.0);
        progressVoice.value = 0;
      }
      this.muteState = !this.muteState;
    };

    //全屏按钮点击事件
    fullScreenBtn.onclick = () => {
      if (!this.isFullScreenBtn) {
        // 设置当前全屏播放器ID
        VideoHlsComponent.currentFullscreenPlayerId = this.glplayerId;
        document.documentElement.requestFullscreen();
        // 记录canvas的样式用于还原
        const glplayer = this.elementRef.nativeElement.querySelector('#' + this.glplayerId);
        const playerCanvas = glplayer.querySelector('canvas');
        if (playerCanvas) {
          this.canvasStyle.marginLeft = parseInt(getComputedStyle(playerCanvas).marginLeft) || 0;
          this.canvasStyle.marginTop = parseInt(getComputedStyle(playerCanvas).marginTop) || 0;
          this.canvasStyle.width = playerCanvas.offsetWidth;
          this.canvasStyle.height = playerCanvas.offsetHeight;
        }
      } else {
        document.exitFullscreen();
      }
    };

    // 全屏监听
    this.fullscreenHandler = (event: Event) => {
      // 只处理当前触发全屏的播放器
      if (VideoHlsComponent.currentFullscreenPlayerId === this.glplayerId) {
        if (document.fullscreenElement) {
          const screenWidth = window.screen.width;
          const screenHeight = window.screen.height;
          this.updatePlayerSize('fullscreen', screenWidth, screenHeight);
          this.isFullScreenBtn = true;
          // 添加全屏时的样式
          playerCont.style.position = 'fixed';
          playerCont.style.top = '0';
          playerCont.style.left = '0';
          playerCont.style.zIndex = '10001';
        } else {
          this.updatePlayerSize('normal', config.width, config.height);
          this.isFullScreenBtn = false;
          // 退出全屏时清除当前全屏播放器ID
          VideoHlsComponent.currentFullscreenPlayerId = null;
          // 恢复正常样式
          playerCont.style.position = 'relative';
          playerCont.style.top = 'auto';
          playerCont.style.left = 'auto';
          playerCont.style.zIndex = 'auto';
        }
      }
    };
    document.addEventListener('fullscreenchange', this.fullscreenHandler);

    //进度条点击事件
    progressCont.addEventListener('click', (e: any) => {
      showLabel.textContent = this.SHOW_LOADING;
      let x = e.pageX - progressCont.getBoundingClientRect().left; // or e.offsetX (less support, though)
      let y = e.pageY - progressCont.getBoundingClientRect().top;  // or e.offsetY
      let clickedValue = x * progressCont.max / progressCont.offsetWidth;
      playerObj.seek(clickedValue);
    });

    //进度条音量点击事件
    progressVoice.addEventListener('click', (e: any) => {
      let x = e.pageX - progressVoice.getBoundingClientRect().left; // or e.offsetX (less support, though)
      let y = e.pageY - progressVoice.getBoundingClientRect().top;  // or e.offsetY
      let clickedValue = x * progressVoice.max / progressVoice.offsetWidth;
      progressVoice.value = clickedValue;
      let volume = clickedValue / 100;
      playerObj.setVoice(volume);
      this.muteState = volume == 0;
    });

    //进度条开始拖拽事件
    playerObj.onSeekStart = (pts: any) => {
      showLabel.textContent = this.SHOW_LOADING + " seek to:" + parseInt(pts);
    };

    //进度条结束拖拽事件
    playerObj.onSeekFinish = () => {
      showLabel.textContent = this.SHOW_DONE;
    };

    //播放结束事件
    playerObj.onPlayFinish = () => {
      console.log("============= FINISHED ===============");
      this.isPlaying = false;
    };

    //渲染事件
    playerObj.onRender = (width: any, height: any, imageBufferY: any, imageBufferB: any, imageBufferR: any) => {
      console.log("on render");
    };

    //打开全屏事件
    playerObj.onOpenFullScreen = () => {
      console.log("onOpenFullScreen");
    };

    //关闭全屏事件
    playerObj.onCloseFullScreen = () => {
      console.log("onCloseFullScreen");
    };

    //进度条结束拖拽事件
    playerObj.onSeekFinish = () => {
      showLabel.textContent = this.SHOW_DONE;
    };

    //加载缓存事件
    playerObj.onLoadCache = () => {
      showLabel.textContent = "Caching...";
    };

    //加载缓存完成事件
    playerObj.onLoadCacheFinshed = () => {
      showLabel.textContent = this.SHOW_DONE;
    };

    //准备完成事件
    playerObj.onReadyShowDone = () => {
      console.log("onReadyShowDone");
      showLabel.textContent = "Cover Img OK";
      this.networkState = 5;
    };

    //加载完成事件
    playerObj.onLoadFinish = () => {
      mediaInfo = playerObj.mediaInfo();
      console.log("mediaInfo===========>", mediaInfo);
      if (mediaInfo.meta.isHEVC === false) {
        console.log("is not HEVC/H.265 media!");
        playerObj.release();
        this.isH265 = false;
        setTimeout(() => {
          this.initVideo();
        }, 200);
        return;
      }

      playBtn.disabled = false;

      //视频类型
      if (mediaInfo.videoType == "vod") {
        cachePts.max = mediaInfo.meta.durationMs / 1000;
        progressCont.max = mediaInfo.meta.durationMs / 1000;
        ptsLabel.textContent = this.ls.durationText(0) + '/' + this.ls.durationText(progressCont.max);
      } else {
        cachePts.hidden = true;
        progressCont.hidden = true;
        ptsLabel.textContent = 'LIVE';
      }

      //封面按钮点击事件
      coverBtn.onclick = () => {
        playAction();
      };

      //没有音频
      if (mediaInfo.meta.audioNone) {
        progressVoice.value = 0;
        progressVoice.style.display = 'none';
        this.muteState = true;
      } else {
        if (this.mutedMode) {
          playerObj.setVoice(0.0);
          progressVoice.value = 0;
          this.muteState = true;
        } else {
          playerObj.setVoice(0.5);
          progressVoice.value = 50;
          this.muteState = false;
        }
      }

      //自动播放
      if (this.autoplayMode) {
        playAction();
      } else {
        coverToast.removeAttribute('hidden');
      }

      showLabel.textContent = this.SHOW_DONE;
    };

    //缓存进度事件
    playerObj.onCacheProcess = (cPts: any) => {
      try {
        let precent = cPts / progressCont.max;
        let cacheWidth = precent * progressContW;
        cachePts.style.width = cacheWidth + 'px';
      } catch (err) {
        console.log(err);
      }
    };

    //播放时间事件
    playerObj.onPlayTime = (videoPTS: any) => {
      if (mediaInfo.videoType == "vod") {
        let precent = videoPTS / progressCont.max;
        let progWidth = precent * progressContW;
        progressPts.style.width = progWidth + 'px';
        ptsLabel.textContent = this.ls.durationText(videoPTS) + '/' + this.ls.durationText(progressCont.max);
      } else {
        ptsLabel.textContent = 'LIVE';
      }
    };

    playerObj.do();
    this.ncLoaded.emit(this.player);
  }

  // 抽取尺寸更新逻辑到单独的方法
  private updatePlayerSize(mode: string, width: number, height: number) {
    const playerCont = this.elementRef.nativeElement.querySelector('#player-container');
    const controllerCont = this.elementRef.nativeElement.querySelector('#controller');
    const glplayer = this.elementRef.nativeElement.querySelector('#' + this.glplayerId);

    playerCont.style.width = width + 'px';
    playerCont.style.height = height + 'px';
    controllerCont.style.width = width + 'px';
    glplayer.style.width = width + 'px';
    glplayer.style.height = height + 'px';

    // canvas
    const playerCanvas = glplayer.querySelector('canvas');
    if (playerCanvas) {
      if (mode == 'fullscreen') {
        playerCanvas.style.width = width + 'px';
        playerCanvas.style.height = height + 'px';
        playerCanvas.style.marginLeft = '0px';
        playerCanvas.style.marginTop = '0px';
      } else {
        playerCanvas.style.width = this.canvasStyle.width + 'px';
        playerCanvas.style.height = this.canvasStyle.height + 'px';
        playerCanvas.style.marginLeft = this.canvasStyle.marginLeft + 'px';
        playerCanvas.style.marginTop = this.canvasStyle.marginTop + 'px';
      }
    }
  }

  //hls.js
  video!: HTMLVideoElement;
  hls!: Hls;
  playError: boolean = false;
  //初始化
  async initVideo() {
    console.log('启用hls.js!')
    this.destroyAll();//加载前先销毁
    this.video = this.elementRef.nativeElement.querySelector('#video');//获取video

    //hls(m3u8)
    if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
      this.video.src = this.ncUrl;
    } else if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(this.ncUrl);
      this.hls.attachMedia(this.video);
      //错误监听
      this.hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.details == 'bufferStalledError') {
          console.warn('warning:', data.error)
        } else if (data.details == 'fragParsingError') {
          console.warn('warning:', data.error)
        } else if (data.details == 'bufferNudgeOnStall') {
          console.warn('warning:', data.error)
        } else {
          this.playError = true;
          console.error('error:', data.details);
          console.error('error:', data.error);
        }
      });
    }

    //播放监听
    this.video.addEventListener('play', () => {
      this.ncPlaying.emit(true);
    });

    //暂停监听
    this.video.addEventListener('pause', () => {
      this.ncPlaying.emit(false);
    });

    //返回video对象
    this.ncLoaded.emit(this.video);
  }
  //销毁
  destroyAll() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.video) {
      this.destroyVideo(this.video);
    }
  }

  destroyVideo(video: HTMLVideoElement) {
    video.pause();
    video.src = '';
    video.removeEventListener('play', () => { });
    video.removeEventListener('pause', () => { });
    video.removeEventListener('loadedmetadata', () => { });
    video.remove();
  }
}
